import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

// UTILS
import { getReactTableColumns } from "./utils"
import { downloadScreenShotFile } from "Utils/screenshotPage"

//STYLE
import { TableContainer } from "./WidgetTable.styles"

// COMPONENTS
import Table from "./components/Table"
import WithWindowDimensions from "./components/WindowDimensionsWrapper"

const WidgetTable = ({
  enableFilters,
  enableFooters,
  enableCountRow,
  enablePagination,
  nbRowsPerPage,
  enableExportMenu,
  widgetTitle,
  widgetTraduction,
  ////// DATAS
  columnsLabelsMapping,
  dataChart,
  ////// STYLES
  //// CONTAINER
  width,
  height,
  border,
  borderRadius,
  backgroundColor,
  //// HEAD
  headBackgroundColor,
  headFontSize,
  headColor,
  headHeight,
  headBorder,
  headBorderRadius,
  // HEAD CELLS
  headCellJustifyContent,
  displayHeadCellSeparator,
  headCellSeparator,
  //// BODY
  bodyBackgroundColor,
  bodyHeight,
  /// BODY ROWS
  displayBodyRowSeparator,
  bodyRowSeparator,
  bodyRowBorderRadius,
  bodyOddRowBackgroundColor, // IMPAIR
  bodyEvenRowBackgroundColor, // PAIR
  // BODY CELLS
  bodyCellHeight,
  bodyCellJustifyContent,
  bodyCellAlignItems,
  displayBodyCellSeparator,
  bodyCellSeparator,
  numberDecimal,
  showSpaceForThousand,
  // FOOT
  footBackgroundColor,
  footColor,
  footHeight,
  footBorder,
  footBorderRadius,
  // FOOT CELLS
  footCellJustifyContent,
  footCellAlignItems,
  displayFootCellSeparator,
  footCellSeparator,
  footCellFontWeight,
  // PAGINATION
  paginationColor,
  // STICKY COLUMN
  freezeFirstColumn,
  windowHeight,
  exportMenuPosition,
}) => {
  const [calculatedBodyHeight, setCalculatedBodyHeight] = useState(bodyHeight)
  const [calculatedTableHeight, setCalculatedTableHeight] = useState(height)
  const [calculatedNbRowsPerPage, setCalculatedNbRowsPerPage] = useState(100)

  const [tableComponentId] = useState(`TableComponent${Math.random()}`)
  const [exportMenuId] = useState(`exportMenu${Math.random()}`)

  const caculatedHeadHeight = enableFilters ? parseInt(headHeight) + 35 + "px" : headHeight

  useEffect(() => {
    var rowsPerPage = dataChart.length
    if (enablePagination && Boolean(nbRowsPerPage)) {
      rowsPerPage = parseInt(nbRowsPerPage)
    }
    setCalculatedNbRowsPerPage(rowsPerPage)
  }, [enablePagination, nbRowsPerPage, dataChart])

  var numberDecimalToUse = 3
  if (numberDecimal !== undefined && typeof numberDecimal === "number")
    numberDecimalToUse = numberDecimal

  var freezeFirstColumnToUse = false
  if (freezeFirstColumn !== undefined) freezeFirstColumnToUse = freezeFirstColumn

  var reactColumnOptions = {
    enableFilters,
    enableFooters,
    showSpaceForThousand,
    numberDecimal: numberDecimalToUse,
    freezeFirstColumn: freezeFirstColumnToUse,
  }

  const columns = getReactTableColumns(columnsLabelsMapping, reactColumnOptions)
  const finalExportMenuPosition = {
    top: "0px",
    right: "5px",
    ...exportMenuPosition,
  }
  const pdfExportStyles = {
    headStyles: {
      textColor: headColor,
      fillColor: headBackgroundColor,
    },
  }

  const hideElement = element => {
    element.style.display = "none"
  }

  const exportPNG = () => {
    const title = widgetTitle.replace(/ /g, "_")
    const exportMenu = document.getElementById(exportMenuId)
    hideElement(exportMenu)
    // take the screen and export
    downloadScreenShotFile(tableComponentId, title)
    // display again the menu
    setTimeout(() => exportMenu.removeAttribute("style"), 10) // ten milliseconds is invisible for the user
  }

  const calcBodyHeight = () => {
    if (bodyHeight === "") {
      const container = document.getElementById(tableComponentId)
      const heightHeader = parseInt(caculatedHeadHeight)
      const heightFooter = enableFooters ? parseInt(footHeight) : 0
      const heightPagination = enablePagination ? 40 : 0
      const heightExportMenu = enableExportMenu ? 40 : 0
      const containerHeight = container.clientHeight
      const height =
        containerHeight -
        heightHeader -
        heightFooter -
        heightPagination -
        heightExportMenu -
        14 +
        "px"
      const tableHeight = containerHeight - heightPagination - heightExportMenu - 14 + "px"
      if (calculatedTableHeight !== tableHeight) setCalculatedTableHeight(tableHeight)
      if (calculatedBodyHeight !== height) setCalculatedBodyHeight(height)
    }
  }

  useEffect(() => {
    calcBodyHeight()
  }, [windowHeight, enableExportMenu, enableFooters, enablePagination])

  return (
    <TableContainer
      id={tableComponentId}
      //// CONTAINER
      width={width}
      height={height}
      border={border}
      borderRadius={borderRadius}
      backgroundColor={backgroundColor}
      tableHeight={calculatedTableHeight}
      enableExportMenu={enableExportMenu}
      //// HEAD
      headBackgroundColor={headBackgroundColor}
      headFontSize={headFontSize}
      headColor={headColor}
      headHeight={caculatedHeadHeight}
      headBorder={headBorder}
      headBorderRadius={headBorderRadius}
      // HEAD CELLS
      headCellJustifyContent={headCellJustifyContent}
      headCellJustifyContentIfFilterEnable={enableFilters}
      displayHeadCellSeparator={displayHeadCellSeparator}
      headCellSeparator={headCellSeparator}
      //// BODY
      bodyBackgroundColor={bodyBackgroundColor}
      bodyHeight={calculatedBodyHeight}
      /// BODY ROWS
      displayBodyRowSeparator={displayBodyRowSeparator}
      bodyRowSeparator={bodyRowSeparator}
      bodyRowBorderRadius={bodyRowBorderRadius}
      bodyOddRowBackgroundColor={bodyOddRowBackgroundColor}
      bodyEvenRowBackgroundColor={bodyEvenRowBackgroundColor}
      // BODY CELLS
      bodyCellHeight={bodyCellHeight}
      bodyCellJustifyContent={bodyCellJustifyContent}
      bodyCellAlignItems={bodyCellAlignItems}
      displayBodyCellSeparator={displayBodyCellSeparator}
      bodyCellSeparator={bodyCellSeparator}
      // FOOT
      footBackgroundColor={footBackgroundColor}
      footColor={footColor}
      footHeight={footHeight}
      footBorder={footBorder}
      footBorderRadius={footBorderRadius}
      // FOOT CELLS
      footCellJustifyContent={footCellJustifyContent}
      footCellAlignItems={footCellAlignItems}
      displayFootCellSeparator={displayFootCellSeparator}
      footCellSeparator={footCellSeparator}
      footCellFontWeight={footCellFontWeight}
      // STICKY COLUMN
      freezeFirstColumn={freezeFirstColumn}
    >
      <Table
        columns={columns}
        data={dataChart}
        enableFilters={enableFilters}
        enableFooters={enableFooters}
        enablePagination={enablePagination}
        nbRowsPerPage={calculatedNbRowsPerPage}
        enableExportMenu={enableExportMenu}
        enableCountRow={enableCountRow}
        exportPNG={exportPNG}
        exportsTitle={widgetTitle}
        exportMenuId={exportMenuId}
        widgetTraduction={widgetTraduction}
        // STYLES
        paginationColor={paginationColor}
        exportMenuPosition={finalExportMenuPosition}
        pdfExportStyles={pdfExportStyles}
        // STICKY COLUMN
        freezeFirstColumn={freezeFirstColumn}
      />
    </TableContainer>
  )
}

WidgetTable.propTypes = {
  ////// DATAS
  columnsLabelsMapping: PropTypes.arrayOf(PropTypes.object),
  dataChart: PropTypes.arrayOf(PropTypes.object),
  enableFilters: PropTypes.bool,
  enableFooters: PropTypes.bool,
  enableCountRow: PropTypes.bool,
  enablePagination: PropTypes.bool,
  nbRowsPerPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  enableExportMenu: PropTypes.bool,
  widgetTitle: PropTypes.string,
  isEdition: PropTypes.bool,
  ////// STYLE
  //// CONTAINER
  width: PropTypes.string,
  height: PropTypes.string,
  border: PropTypes.string,
  borderRadius: PropTypes.string,
  backgroundColor: PropTypes.string,
  //// HEAD
  headBackgroundColor: PropTypes.string,
  headColor: PropTypes.string,
  headHeight: PropTypes.string,
  headBorder: PropTypes.string,
  headBorderRadius: PropTypes.string,
  // HEAD CELLS
  headCellJustifyContent: PropTypes.string,
  headCellJustifyContentIfFilterEnable: PropTypes.bool,
  displayHeadCellSeparator: PropTypes.bool,
  headCellSeparator: PropTypes.string,
  //// BODY
  bodyBackgroundColor: PropTypes.string,
  bodyHeight: PropTypes.string,
  /// BODY ROWS
  displayBodyRowSeparator: PropTypes.bool,
  bodyRowSeparator: PropTypes.string,
  bodyRowBorderRadius: PropTypes.string,
  bodyOddRowBackgroundColor: PropTypes.string,
  bodyEvenRowBackgroundColor: PropTypes.string,
  // BODY CELLS
  bodyCellHeight: PropTypes.string,
  bodyCellJustifyContent: PropTypes.string,
  bodyCellAlignItems: PropTypes.string,
  displayBodyCellSeparator: PropTypes.bool,
  bodyCellSeparator: PropTypes.string,
  numberDecimal: PropTypes.number,
  showSpaceForThousand: PropTypes.bool,
  // FOOT
  footBackgroundColor: PropTypes.string,
  footColor: PropTypes.string,
  footHeight: PropTypes.string,
  footBorder: PropTypes.string,
  footBorderRadius: PropTypes.string,
  // FOOT CELLS
  footCellJustifyContent: PropTypes.string,
  footCellAlignItems: PropTypes.string,
  displayFootCellSeparator: PropTypes.bool,
  footCellSeparator: PropTypes.string,
  footCellFontWeight: PropTypes.string,
  // PAGINATION
  paginationColor: PropTypes.string,
  // STICKY COLUMN
  freezeFirstColumn: PropTypes.bool,
  exportMenuPosition: PropTypes.object,
}

WidgetTable.defaultProps = {
  ////// DATAS
  columnsLabelsMapping: [],
  dataChart: [],
  enableFilters: false,
  enableFooters: false,
  enableCountRow: false,
  enablePagination: false,
  nbRowsPerPage: 100,
  enableExportMenu: false,
  widgetTitle: "title",
  isEdition: false,
  ////// STYLE
  //// CONTAINER
  width: "100%",
  height: "100%",
  border: "",
  borderRadius: "4px",
  backgroundColor: "#fff",
  //// HEAD
  headBackgroundColor: "#01014B",
  headColor: "#333",
  headHeight: "30px",
  headBorder: "",
  headBorderRadius: "4px",
  // HEAD CELLS
  headCellJustifyContent: "center",
  headCellJustifyContentIfFilterEnable: false,
  displayHeadCellSeparator: false,
  headCellSeparator: "1px solid #333",
  //// BODY
  bodyBackgroundColor: "#fff",
  bodyHeight: "",
  // BODY ROWS
  displayBodyRowSeparator: true,
  bodyRowSeparator: "1px solid #333",
  bodyRowBorderRadius: "4px",
  bodyOddRowBackgroundColor: "#FFFFFF",
  bodyEvenRowBackgroundColor: "#F4F4F4",
  // BODY CELLS
  bodyCellHeight: "30px",
  bodyCellJustifyContent: "center",
  bodyCellAlignItems: "center",
  displayBodyCellSeparator: true,
  bodyCellSeparator: "1px solid #333",
  numberDecimal: 0,
  showSpaceForThousand: false,
  // FOOT
  footBackgroundColor: "#01014B",
  footColor: "#333",
  footHeight: "30px",
  footBorder: "",
  footBorderRadius: "4px",
  // FOOT CELLS
  footCellJustifyContent: "center",
  footCellAlignItems: "center",
  displayFootCellSeparator: false,
  footCellSeparator: "1px solid #333",
  footCellFontWeight: "bold",
  // PAGINATION
  paginationColor: "#7F7F7F",
  // STICKY COLUMN
  freezeFirstColumn: false,
  exportMenuPosition: {},
}

export default WithWindowDimensions(WidgetTable)
